import range from "lodash/range";

export function addQueuedSubmissions(queue = [], submission, turnsToWait = 1) {
  if (turnsToWait < 1) {
    console.warn("turnsToWait must be 1 or more ");
    return [];
  }

  const newLength =
    queue.length > turnsToWait
      ? queue.length //output is going to have the same length as our current queue
      : turnsToWait; //output will be longer than our current queue (this is setting in the last position)

  const addToIndex = turnsToWait - 1;

  return range(newLength).map(index => {
    const turnActions = (queue[index] || {}).actions || [];
    const addToActions = addToIndex === index ? [{ ...submission }] : [];

    return {
      turnSpot: true,
      actions: [...turnActions, ...addToActions]
    };
  });
}

export function extractQueuedSubmissions(queue = []) {
  /* Check the first in queue line for submissions. Return empty turnModel if no length */
  return queue.length
    ? queue[0]
    : {
        turnSpot: true,
        actions: []
      };
}

export function removeQueueSlot(queue = []) {
  /* Move the queue train forward by removing the first in the queue*/
  return queue.filter((d, i) => {
    return i > 0;
  });
}



// WEBPACK FOOTER //
// ./src/battle/cloud-queue.js